// Lightweight helper to reveal text one character at a time
export default function animateReveal(container, text, opts = {}) {
  const interval = opts.interval ?? 20;
  const charClass = opts.charClass ?? 'char';
  const visibleClass = opts.visibleClass ?? 'char-visible';
  const risenClass = opts.risenClass ?? 'char-risen';
  const riseDelay = opts.riseDelay ?? 160;
  const prefersReduced = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return new Promise((resolve) => {
    if (!container) return resolve();
    container.innerHTML = '';

    // If user prefers reduced motion, show immediately
    if (prefersReduced) {
      text.split('').forEach((ch) => {
        const s = document.createElement('span');
        s.className = `${charClass} ${visibleClass} ${risenClass}`;
        s.textContent = ch;
        container.appendChild(s);
      });
      resolve();
      return;
    }

    let i = 0;
    const appendNext = () => {
      if (i >= text.length) {
        resolve();
        return;
      }
      const ch = text[i];

      const span = document.createElement('span');
      span.className = charClass;
      span.textContent = ch;
      container.appendChild(span);

      // Force a reflow so the browser acknowledges the initial styles
      // before we add the visible class. This prevents the letter from
      // snapping to opaque without transition in some browsers.
      // eslint-disable-next-line no-unused-expressions
      span.offsetWidth;

      // Trigger opacity fade first, then translate up shortly after
      requestAnimationFrame(() => span.classList.add(visibleClass));
      setTimeout(() => span.classList.add(risenClass), riseDelay);

      i += 1;
      setTimeout(appendNext, interval);
    };

    appendNext();
  });
}
